export enum CalendarZoomLevelEnum {
    CENTURY = 'century',
    DECADE = 'decade',
    YEAR = 'year',
    MONTH = 'month',
  }